import { Grid } from '@mui/material';
import { QuizResult as Result } from '@components/Quiz/Result';

export const QuizResult = () => (
  <Grid container flexDirection="column" sx={{ mt: 6, width: '100%' }}>
    <Result />
  </Grid>
);
